export default function Try(){
    return(
       <body>
        </body>
       
    );
}